//#region [IMPORT]

// === THIRD-PARTY
import React, { createContext, useEffect } from 'react';

// === STYLE ===
import { useTheme } from '@mui/material/styles';
import { TableCell, Chip, IconButton, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

// === API ===
import { roleModuleCreate, roleModuleRemove } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function RoleModules(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { roleModules: role_modules, availableModules: available_modules, roleId: role_id, refreshRoles } = props;

  const module_options = available_modules.map((module) => {
    return { label: module.ModuleName, value: module.id.toString() };
  });

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function handleModuleDelete(module_id_raw) {
    //-----------------------------------------------------------------
    const module_id = parseInt(module_id_raw);

    if ( isNaN(module_id) ) return;
    
    roleModuleRemove(role_id, module_id);
  };

  //-----------------------------------------------------------------
  function handleAddButtonClick(event) {
    //-----------------------------------------------------------------
    setAnchorEl(event.currentTarget);
  };

  //-----------------------------------------------------------------
  function handleModuleSelectClose() {
    //-----------------------------------------------------------------
    setAnchorEl(null);
  };

  //-----------------------------------------------------------------
  function handleModuleSelectAdd(module_id_raw) {
    //-----------------------------------------------------------------
    setAnchorEl(null);

    const module_id = parseInt(module_id_raw);
    if ( isNaN(module_id) ) return;

    roleModuleCreate(role_id, module_id);
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function displayTags() {
    //-----------------------------------------------------------------
    return role_modules.map((module) => {
      return (
        <Chip
          key={module.id}
          label={module.ModuleName}
          sx={{
            margin: theme.spacing(0.25),
          }}
          size='small'
          onDelete={() => handleModuleDelete(module.id)}
        />
      );
    });
  }

  //-----------------------------------------------------------------
  function displayModuleSelection() {
    //-----------------------------------------------------------------
    return (
      <div sx={{
        display: 'inline-block',
        marginLeft: 'auto',
      }}>
        <IconButton
          aria-label='add-module'
          aria-controls='add-module'
          aria-haspopup='true'
          color='primary'
          disabled={module_options.length === 0}
          onClick={handleAddButtonClick}
        >
          <AddIcon fontSize='small' />
        </IconButton>
        <Menu id='module-menu' anchorEl={anchorEl} keepMounted open={open} onClose={handleModuleSelectClose}>
          {module_options.map((option) => {
            return (
              <MenuItem key={option.value} onClick={() => handleModuleSelectAdd(option.value)} name='add_role_module_btn'>
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
      </div>
    );
  }

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <TableCell>
        {displayTags()}
        {displayModuleSelection()}
      </TableCell>
    );
  }

  //#endregion

  return display();
}
